import React, { useState, useEffect } from "react";

import { ConfirmationModal } from "components";

import { func_validation } from "functions";


export function useDeleteUser(props) {
    const {
        deleteUser_requesting,
        setAlertMsg,
        selectedUsers,
        isUserRecordUpdatedSuccessfully
    } = props;

    const [isModalVisible_deleteUser, setIsModalVisible_deleteUser] = useState(false);

    function deleteUser() {
        setAlertMsg([]);
    
        selectedUsers.map((userInfo, idx) => { 
            let userId = func_validation.getObjectPropertyValue(userInfo, "UserId");

            if (func_validation.isNumberValid(userId) &&
                func_validation.isFunction(props.deleteUser)) {

                props.deleteUser(userId);
            }
        });
    }

    let modalDisplay = (
        <ConfirmationModal
            description={"The selected user(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_deleteUser}
            updateParentState={setIsModalVisible_deleteUser}
            handleOnConfirm={deleteUser}
            isConfirmSuccessful={isUserRecordUpdatedSuccessfully}
            isActionLoading={deleteUser_requesting}
        />
    );

    return {
        modalDisplay,
        setIsModalVisible_deleteUser
    }
}